import React from 'react';
import { Activity, Clock } from 'lucide-react';
import OrderbookDepth from './OrderbookDepth';

export const OrderbookView = ({ outcome, orderbook, recentTrades }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="bg-[#131b2e] rounded-xl p-3">
        <h4 className="text-xs font-semibold text-white mb-2 flex items-center gap-1">
          <Activity className="h-3 w-3 text-[#3B82F6]" />
          {outcome} Orderbook
        </h4>
        <div className="grid grid-cols-2 gap-2 text-xs text-gray-500 mb-2">
          <span>BIDS</span>
          <span className="text-right">ASKS</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <OrderbookDepth
            side="bids"
            data={outcome === 'YES' ? orderbook?.yes?.bids : orderbook?.no?.bids}
          />
          <OrderbookDepth
            side="asks"
            data={outcome === 'YES' ? orderbook?.yes?.asks : orderbook?.no?.asks}
          />
        </div>
      </div>

      <div className="bg-[#131b2e] rounded-xl p-3">
        <h4 className="text-xs font-semibold text-white mb-2 flex items-center gap-1">
          <Clock className="h-3 w-3 text-amber-400" />
          Recent Trades
        </h4>
        <div className="space-y-1 max-h-32 overflow-y-auto">
          {recentTrades.slice(0, 5).map((trade, idx) => (
            <div
              key={trade.id || trade.trade_id || `${trade.created_at || 'trade'}-${idx}`}
              className="flex justify-between text-xs"
            >
              <span className={trade.outcome === 'YES' ? 'text-[#3B82F6]' : 'text-[#F97316]'}>
                {trade.outcome} @ {trade.price}¢
              </span>
              <span className="text-gray-500">{trade.quantity} contracts</span>
            </div>
          ))}
          {recentTrades.length === 0 && (
            <div className="text-xs text-gray-500 text-center py-2">No trades yet</div>
          )}
        </div>
      </div>
    </div>
  );
};
